<template>
  <div>
    <!-- <heads></heads> -->
    <div class="wid1200">
       <div class="mart30" v-if="tabListIndex==0 || tabListIndex==1">
        <div class="font30 font600 padtb5">{{detailObj.name}}</div>
          <div>
             <el-link type="info" @click.native="toNext(index)"> 成都写字楼</el-link>
              <el-link type="info" @click.native="toList(detailObj.districtCode, 'qy')"> >{{commonfun.returnRegion(detailObj.districtCode)}}写字楼</el-link>
              <el-link type="info" @click.native="toList(index)"> >{{commonfun.returnBussileList(detailObj.business)}}写字楼</el-link>
              <el-link type="info" @click.native="toList(index)"> >{{detailObj.name}}</el-link>
          </div>
      </div>
      <el-row class="mart30">
        <el-col :span="12">
          <div class="swiper-box" style="height: 550px" v-if="dataList.length > 0">
            <!-- swiper1 -->
            <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
              <swiper-slide v-for="(item,index) in dataList" :key="index">
                <img class="comp-intro-banner img100" :src="item.url" alt="item.title" />
              </swiper-slide>
              <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
              <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
            </swiper>
              <!-- <div v-else>
              <img class="comp-intro-banner img100" src="../../../static/img/wu.png" alt="item.title" />
            </div> -->
            <!-- swiper2 Thumbs -->
            <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
              <swiper-slide v-for="(item,index) in dataList" :key="index" class="slide-1">
                <img class="swiperSmallImg" :src="item.url" alt="item.title" />
              </swiper-slide>
            </swiper>
          </div>
        </el-col>
        <el-col :span="11" :offset="1" class="padt28">
          <div>
            <span class="colred font40 font600">{{detailObj.prices}}</span>
            <span class="font14 col333">元/月</span>
            <span class="font14 col333 padl100">参考单价：{{detailObj.price}}元/m²/月</span>
            <!-- <span class="colred font40 font600">{{detailObj.areas}}-{{detailObj.areae}}m²</span> -->

           
          </div>

          <div class="line40">
            <span class="font14 font600 col333">楼盘名称</span>
            <span class="font14 col999 padl40">{{detailObj.name}}</span>
          </div>
          <div class="line40">
            <span class="font14 font600 col333">建筑面积</span>
            <span
              class="font14 col999 padl40">{{detailObj.areas}}-{{detailObj.areae}}m²</span>
          </div>
          <div class="line40">
            <span class="font14 font600 col333">所在地址</span>
            <span class="font14 col999 padl40">{{detailObj.address}}</span>
          </div>
          <div class="callbox">
            <el-row class>
              <el-col :span="4">
                <img :src="detailObj.wxPhoto" class="icon64" alt />
              </el-col>
              <el-col :span="10" class>
                <div class="line30">
                  <span class="font16 col333 font600">{{detailObj.userName }}</span>
                  <span class="font12 col999">房源顾问</span>
                </div>
                <div class="font14 col333">好评经纪人，熟悉本房特色</div>
              </el-col>
              <el-col :span="10">
                <p class="font20 colred font600 italic line80">{{detailObj.mobile}}</p>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- <el-row class="mart20 font16 col333 bgf5 line30 padtb5 textcenter">
        <el-col :span="20">
          <el-col :span="3" v-for="(item1,index) in tabList" :key="index" @click.native="changeTab(index)"><span :class="tabListIndex==index?'borb':''">{{item1.name}}</span></el-col>

        </el-col>
      </el-row>-->
      <div class="mart50">
        <el-row>
          <el-col :span="16">
            <div>
              <div class="col333 font20 font600 mart30">写字楼概况</div>
              <el-row class="mart20">
                <el-col :span="12">
                  <ul class="msg">
                    <li>
                      建筑面积:
                      <span>{{detailObj.areas}}-{{detailObj.areae}}m²</span>
                    </li>
                    <li>
                      客梯数:
                      <span>{{detailObj.liftElevator}}</span>
                    </li>
                  
                  </ul>
                </el-col>
                <el-col :span="12">
                  <ul class="msg">
                    <li>
                      开发商:
                      <span>{{detailObj.developers}}</span>
                    </li>
                    <li>
                      物业公司:
                      <span>{{detailObj.propertyCompany}}</span>
                    </li>
                  </ul>
                </el-col>
                <el-col :span="24" class="msg">
                     <ul><li>楼盘简介:
                      <span class="line20 disinline">{{detailObj.content}}</span></li></ul> 
                </el-col>
              </el-row>
            </div>
            <div class="mart50">
              <p class="colred font24 font600">楼盘图片</p>
              <el-row class="mart30">
                <el-col :span="12" v-for="(item,index) in dataList" :key="index">
                  <div class="houseImg">
                    <el-image
                      class="detailimg"
                      style="width: 100px; height: 100px"
                      :src="item.url"
                      :preview-src-list="getSrcList(index)"
                    ></el-image>
                    <!-- <img :src="item.url" alt /> -->
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="4" :offset="1">
            <div class="border1 pad10">
              <!-- <p class="font18 col333 font600">果壳里的城+中高楼层...</p>
              <el-row class="borderb padtb15 mart5">
                <el-col :span="6" class="line30">
                  <span class="font20 colred">85</span>
                  <span class="font14">万</span>
                </el-col>
                <el-col :span="18" class="textright font12 line40">参考单价：15406.9元/</el-col>
              </el-row>-->
              <div class="font16 col333 line30 font600">咨询顾问</div>
              <el-row v-for="(item,index) in AgentArr" :key="index" class="padtb10">
                <el-col :span="4">
                  <img :src="item.headUrl" class="icon36" alt />
                </el-col>
                <el-col :span="19" :offset="1">
                  <div class="font14 col000 font600">
                    {{item.userName}}
                    <span class="font12 col999">房源顾问</span>
                  </div>
                  <div class="font12 padtb5 col666">好评经纪人</div>
                  <div class="font12 colred">咨询热线：123123213</div>
                </el-col>
                 <div>
                  <entrust :paramsid='id' type='2'></entrust>
              </div>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <div class="mart50">
          <p class="colred font24 font600">周边配套</p>
           <bdmap class="mart30"  :latitudeVal="detailObj.latitude" :dictName="detailObj.name"></bdmap>
        </div>
        <div class="mart50">
          <p class="colred font24 font600">为你推荐优质房源</p>
          <el-row class="mart30">
            <el-col :span="6" v-for="(item,index) in recommendList" :key="index">
              <div class="wid95">
                <el-image v-if="item.imageUrl" :src="item.imageUrl" alt />
                <el-image v-else src="http://img.sccshf.com/defaultimage1.png"  />
                <div class="font14 col000">{{item.dictName}}</div>
                <el-row class="line30">
                  <el-col
                    :span="14"
                    class="font12 col999"
                  >{{commonfun.returnRegion(item.districtCode)}}-{{commonfun.returnBussileList(item.business)}}</el-col>
                  <el-col :span="10" class="textright">
                    <span class="font16 colred font600">{{item.prices}}</span>
                    <span class="font12 colred">万</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bdmap from "../../components/baiduMapView";
import "swiper/dist/css/swiper.css";
import entrust from '../../components/entrust';
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "newhouseDetail",
  data() {
    return {
      id: "",
      type: "",
      // id:'',
      detailObj: {},
      dataList: [],
      BigImg: [],
      recommendall: {
        page: 1,
        limit: 5,
        orderField: "",
        tenant_code: this.$store.state.tenantCode, //城市编码
        order: "",
        dictId: ""
      },
      recommendallList:[],
      recomIndex:0,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      houseSouse: [],
      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 4,
        touchRatio: 0.2,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        slideToClickedSlide: true
      },
      tabList: [
        { name: "基本信息", id: "0" },
        { name: "配套设施", id: "1" },
        { name: "带看反馈", id: "2" },
        { name: "房源图片", id: "3" },
        { name: "周边配套", id: "4" },
        { name: "优房推荐", id: "5" }
      ],
      tabListIndex: 0,
      followparmas: {
        page: 1,
        limit: 10,
        orderField: "",
        order: "",
        id: ""
      },
      followArr: [],
      AgentArr: [],
      recommend: {
        page: 1,
        limit: 4,
        orderField: "",
        tenant_code: this.$store.state.tenantCode, //城市编码
        order: "",
        dictId: ""
      },
      recommendList: [],
      followNum: "暂无数据",
      total:'',
      downStatus:false,
    };
  },
  components: {   
    bdmap,
    swiper,
    swiperSlide,
    entrust
  },
  created() {
    //  console.log(this.$route.query.houseid)
    this.id = this.$route.query.houseid;
    this.recommendall.dictId =this.$route.query.houseid;
    this.followparmas.houseId = this.id;
    this.getDtail();
    this.getpageImage();
    this.getAgent();
    this.getrecommendList('lease')
  },
  mounted() {
    this.$emit('getMenuId', 5);
  },
  methods: {
    clickRow(row, column, event){
      console.log(row, column, event)
        if(this.recomIndex==0){
          // houseid
        let routeUrl = this.$router.resolve({
          path: "/officeLeaseDetail",
          query: {
            houseid: row.id
          }
        });
        window.open(routeUrl.href, "_blank");
        }else{
        let routeUrl = this.$router.resolve({
          path: "/officemmdetail",
          query: {
            houseid: row.id
          }
        });
        window.open(routeUrl.href, "_blank");
        }
    },
    getmore(){
      console.log(this.downStatus)
      if(this.downStatus){
        this.recommendall.page=1
        this.recommendall.limit=5;
        this.downStatus=false
      }else{
        this.recommendall.page=1
         this.recommendall.limit=100;
         this.downStatus=true
      }
      if(this.recomIndex==0){
        this.getrecommendList('lease')
      }else{
        this.getrecommendList('sale')
      }
      

    },
    changeTab(id) {
      this.tabListIndex = id;
    },
    // 页面详情
    getDtail() {
      this.$get(this.$api.newHouse.projectInfo, { id: this.id })
        .then(res => {
          console.log("页面详情", res);
          if (res.code == 0) {
            this.detailObj = res.data;
           
            this.detailObj.conf =
            this.detailObj.conf != null ? this.detailObj.conf.split(",") : [];
            this.$nextTick(()=>{
             this.recommendLeaseList('4');
            })
          }
        })
        .catch(err => {
          console.log("页面详情err", err);
        });
    },
    // 页面图片详情
    getpageImage() {
      this.$get(this.$api.newHouse.projectImagelist, { id: this.id ,type:0})
        .then(res => {
          console.log("页面图片详情", res);
          if (res.code == 0) {
            if(res.data.list.length>0){
            this.dataList = res.data.list;
            }else{
             this.dataList.push({url:'http://img.sccshf.com/defaultimage1.png'}) 
            }
            this.$nextTick(() => {
              const swiperTop = this.$refs.swiperTop.swiper;
              const swiperThumbs = this.$refs.swiperThumbs.swiper;
              swiperTop.controller.control = swiperThumbs;
              swiperThumbs.controller.control = swiperTop;
            });
            this.dataList.forEach(item => {
              this.BigImg.push(item.url);
            });
          }
        })
        .catch(err => {
          console.log("页面详情err", err);
        });
    },
    getSrcList(index) {
      return this.BigImg.slice(index).concat(this.BigImg.slice(0, index));
    },
    // 经纪人
    getAgent() {
      this.$get(this.$api.officeBuild.getAgent, { houseId: this.id })
        .then(res => {
          console.log("经纪人", res);
          if (res.code == 0) {
            this.AgentArr = res.data;
          }
        })
        .catch(err => {
          console.log("经纪人err", err);
        });
    },
    recommendLeaseList() {
        console.log("推荐", this.recommend);
      this.$get(this.$api.officeBuild.recommendLeaseList, this.recommend)
        .then(res => {
        
          if (res.code == 0) {
            this.recommendList = res.data.list;
            this.total=res.data.total
          }
        })
        .catch(err => {
          console.log("推荐err", err);
        });
    },
    getrecommendList(type) {
      let url=''
      if(type=='lease'){
       url=this.$api.officeBuild.recommendLeaseList;
       this.recomIndex=0;
      }else{
        url=this.$api.officeBuild.recommendSellList;
        this.recomIndex=1;
      }
      this.recommendallList=[]
      this.$get(url, this.recommendall)
        .then(res => {
         
          if (res.code == 0) {
            res.data.list.forEach(item=>{
              item.houseLabel=item.houseLabel !=null?item.houseLabel.split(','):[];
            })
            this.recommendallList = res.data.list.concat(this.recommendallList);
            this.total=res.data.total
          }
        })
        .catch(err => {
          console.log("推荐err", err);
        });
    },
    cellstyle({ row, column, rowIndex, columnIndex }) {
        return "text-align: center";
    },
    rowclass({ row, rowIndex }) {
        return "text-align: center";
    },
  }
};
</script>

<style  lang="scss">
@import "../office/office.scss";
.bagred{
    display: inline-block;
    width: 80px;
    height: 22px;
    line-height: 22px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: #f73a3a;
    border-radius: 3px; 
    margin-left: 3px;
}
.bag98{
    display: inline-block;
    width: 80px;
    height: 22px;
    line-height: 22px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: #989191;
    border-radius: 3px; 
     margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newhouse/newhouseDetail.vue